import get from 'lodash/get';
import { connect } from 'react-redux';
import { getCurrentUser, getPublicSession } from '../publicSession/selectors';
import { showDealerPopup } from '../Modals/redux/actionCreators';
var mapStateToProps = function (state) { return ({
    userGuid: get(getCurrentUser(state), 'useridUuid'),
    biClientId: get(getPublicSession(state), 'biClientId'),
    biClientIdSigned: get(getPublicSession(state), 'biClientIdSigned'),
}); };
var mapDispatchToProps = {
    showDealerPopup: showDealerPopup,
};
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=DealerAdIframe.container.js.map